import axios from '@pepper/utils/src/function/axiosInstance'
import extract from '@pepper/utils/src/function/extract'

export const createProject = async (title: string, companyId: string) => {
  try {
    const response = await axios.post(`/projects`, {
      company_id: companyId,
      project_title: title,
      assignments: [],
    })
    return extract.data(response)
  } catch (error) {
    return extract.error(error)
  }
}
